import { render, staticRenderFns } from "./discuss.vue?vue&type=template&id=56fac766&scoped=true&"
import script from "./discuss.vue?vue&type=script&lang=js&"
export * from "./discuss.vue?vue&type=script&lang=js&"
import style0 from "./discuss.vue?vue&type=style&index=0&id=56fac766&prod&rel=stylesheet%2Fscss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fac766",
  null
  
)

export default component.exports